import dayjs from 'dayjs';

const getDefaultSplit = () => [
  {
    title: "Today",
    resources: []
  },
  {
    title: "Yesterday",
    resources: []
  },
  {
    title: "Last 7 days",
    resources: []
  },
  {
    title: "Last 30 days",
    resources: []
  },
  {
    title: "Last 12 months",
    resources: []
  },
  {
    title: "Older than 12 months",
    resources: []
  }
];
const splitResourcesByTime = (resources, sortProperty) => {
  const today = dayjs();
  const yesterday = today.subtract(1, "day");
  const last7Days = today.subtract(7, "day");
  const last30Days = today.subtract(30, "day");
  const last12Months = today.subtract(12, "month");
  const divided = resources.reduce((acc, resource) => {
    const resourceDate = dayjs(resource?.[sortProperty]);
    if (resourceDate.isSame(today, "day")) {
      acc[0].resources.push(resource);
    } else if (resourceDate.isSame(yesterday, "day")) {
      acc[1].resources.push(resource);
    } else if (resourceDate.isAfter(last7Days)) {
      acc[2].resources.push(resource);
    } else if (resourceDate.isAfter(last30Days)) {
      acc[3].resources.push(resource);
    } else if (resourceDate.isAfter(last12Months)) {
      acc[4].resources.push(resource);
    } else {
      acc[5].resources.push(resource);
    }
    return acc;
  }, getDefaultSplit()).filter((division) => division.resources.length > 0);
  const firstResource = resources[0];
  const lastResource = resources[resources.length - 1];
  if (firstResource && lastResource && dayjs(firstResource.createdAt).isBefore(dayjs(lastResource.createdAt))) {
    return divided.slice(0).reverse();
  } else {
    return divided;
  }
};

export { splitResourcesByTime };
//# sourceMappingURL=splitResourcesByTime.js.map
